"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var CheckCircle_1 = __importDefault(require("@material-ui/icons/CheckCircle"));
var RadioButtonUnchecked_1 = __importDefault(require("@material-ui/icons/RadioButtonUnchecked"));
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var styles_1 = __importDefault(require("./styles"));
var PasswordStrengthIndicator = function (_a) {
    var _b, _c;
    var password = _a.password, passwordErrors = _a.passwordErrors;
    var theme = (0, core_1.useTheme)();
    var classes = (0, styles_1.default)(theme)();
    var passMinLength = !passwordErrors.includes('min');
    var passCase = !passwordErrors.includes('lowercase') && !passwordErrors.includes('uppercase');
    var passSpecialChar = !passwordErrors.includes('symbols') && !passwordErrors.includes('digits');
    var strengthText;
    var strength;
    if (!password || password.length === 0) {
        strengthText = 'No Password';
        strength = 0;
    }
    else if (passwordErrors.length <= 0 ||
        (passwordErrors.length === 1 && passwordErrors.includes('max'))) {
        strengthText = 'Strong';
        strength = 100;
    }
    else if (passwordErrors.length <= 2 && passwordErrors.length > 0) {
        strengthText = 'Medium';
        strength = 65;
    }
    else {
        strengthText = 'Very Weak';
        strength = 35;
    }
    var passwordErrorMessages = [
        {
            pass: passMinLength,
            text: "Minimum of 8 characters."
        },
        {
            pass: passCase,
            text: "At least one lower and upper case alphabet."
        },
        {
            pass: passSpecialChar,
            text: "At least one number and one special character."
        }
    ];
    var unCheckIcon = (react_1.default.createElement(RadioButtonUnchecked_1.default, { "aria-label": "Condition not met", "aria-hidden": "false", className: classes.errorCheckboxUncheck }));
    var checkIcon = (react_1.default.createElement(CheckCircle_1.default, { "aria-label": "Condition met", "aria-hidden": "false", className: "".concat(classes.errorCheckbox, " checked-icon") }));
    return (react_1.default.createElement(core_1.Grid, { item: true, xs: 12, container: true },
        react_1.default.createElement(core_1.Grid, { container: true, justifyContent: "space-between", alignItems: "center" },
            react_1.default.createElement(core_1.Typography, { variant: "body2", className: classes.strengthBarTitleText }, "Password Strength"),
            react_1.default.createElement(core_1.Typography, { "aria-live": "assertive", className: classes.strengthBarWeaknessText },
                "\u00A0",
                strengthText)),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, className: classes.barContainer },
            react_1.default.createElement(core_1.LinearProgress, { "aria-hidden": "true", variant: "determinate", value: strength, style: { flex: 1, width: '100%' }, classes: {
                    barColorPrimary: (0, classnames_1.default)((_b = {},
                        _b[classes.weak] = passwordErrors.length > 2,
                        _b[classes.medium] = passwordErrors.length <= 2 && passwordErrors.length > 0,
                        _b[classes.strong] = passwordErrors.length === 0,
                        _b[classes.noPassword] = !password || password.length === 0,
                        _b.strong = passwordErrors.length === 0,
                        _b)),
                    colorPrimary: (0, classnames_1.default)((_c = {},
                        _c[classes.weakBar] = passwordErrors.length > 2,
                        _c[classes.mediumBar] = passwordErrors.length <= 2 && passwordErrors.length > 0,
                        _c[classes.strongBar] = passwordErrors.length === 0,
                        _c[classes.noPasswordBar] = !password || password.length === 0,
                        _c))
                } })),
        react_1.default.createElement(core_1.Box, { className: classes.strengthBarSpecificationBox }, passwordErrorMessages.map(function (passwordErrorMessage) { return (react_1.default.createElement(core_1.Box, { sx: { display: 'flex', gridGap: '4px' }, key: passwordErrorMessage.text },
            react_1.default.createElement(core_1.Box, { "aria-hidden": "true", sx: {
                    display: 'flex',
                    height: '18px',
                    width: '18px',
                    alignItems: 'center'
                } }, passwordErrorMessage.pass ? checkIcon : unCheckIcon),
            react_1.default.createElement(core_1.Box, { sx: { display: 'flex', flexDirection: 'column' } },
                react_1.default.createElement(core_1.Typography, { "aria-hidden": "true", className: classes.strengthBarSpecificationText, variant: "caption" }, passwordErrorMessage.text),
                react_1.default.createElement(core_1.Typography, { "aria-live": "polite", variant: 'srOnly' }, "Condition ".concat(passwordErrorMessage.pass ? 'met' : 'not met', ": ").concat(passwordErrorMessage.text))))); }))));
};
exports.default = PasswordStrengthIndicator;
//# sourceMappingURL=PasswordStrengthIndicator.js.map